import { SideMenuLeftConfig } from '../../../components/SideMenu/props'

const accordionStyle = {
  accordionItemGroup: {
    accordionContent: {
      backgroundColor: '#EAEAEA',
      pl: '$8',
      pr: '$18'
    },
    accordionTitle: {
      title: {
        fontFamily: '$primary',
        fontSize: '$caption5',
        fontWeight: '$caption5',
        lineHeight: '$caption5',
        m: '0px',
        py: '$2',
        pl: '$8',
        pr: '$18',
        height: 'max-content',
        minHeight: '40px'
      },
      iconButton: {
        height: '24px',
        width: '24px'
      }
    }
  }
}

export const sideMenuLeft: SideMenuLeftConfig = {
  sectionHeader: {
    enabled: true,
    subscriberInfo: {
      enabled: false,
      amountLeft: 0
    },
    variants: {
      anonymous: {
        logo: {
          name: 'BannerPodcastCBN',
          href: '/'
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$secondaryMain',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            mb: '$6',
            width: '100%'
          },
          iconColor: 'basicBlack',
        }
      },
      DEGUSTADOR: {
        logo: {
          name: 'BannerPodcastCBN',
          href: '/'
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$secondaryMain',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            mb: '$6',
            width: '100%'
          },
          iconColor: 'basicBlack',
        }
      },
      ASSINANTE: {
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$secondaryMain',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            width: '100%'
          },
          iconColor: 'basicBlack',
        }
      },
      advertiser_subscriber: {
        logo: {
          name: 'BannerPodcastCBN',
          href: '/'
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$secondaryMain',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            width: '100%'
          },
          iconColor: 'basicBlack',
        }
      },
      club_subscriber: {
        logo: {
          name: 'BannerPodcastCBN',
          href: '/'
        },
        css: {
          container: {
            align: ['column', 'center', 'top'],
            backgroundColor: '$secondaryMain',
            height: '150px',
            px: '$2',
            width: '100%'
          },
          iconContainer: {
            align: ['row', 'right', 'middle'],
            width: '100%'
          },
          iconColor: 'basicBlack'
        }
      }
    }
  },
  sectionContent: {
    enabled: true,
    searchInput: {
      enabled: true,
    },
    serviceButtons: {
      enabled: false,
      items: []
    },
    navigationAccordions: {
      enabled: true,
      css: accordionStyle,
      items: [
        {
          id: 'sac',
          title: 'SAC',
          items: [
            {
              id: '1',
              title: 'Fale Conosco',
              href: '/fale-conosco'
            },
            {
              id: '2',
              title: 'Expediente',
              href: '/expediente'
            },
            {
              id: '3',
              title: 'Política de privacidade',
              href: '/politica-de-privacidade'
            },
            {
              id: '4',
              title: 'Termos de uso',
              href: '/termos-de-uso'
            }
          ],
          css: accordionStyle
        },
        {
          id: 'grupoojc',
          title: 'Grupo Jaime Câmara',
          items: [
            // FIXME rm classi
            {
              id: '1',
              title: 'Classi',
              href: 'https://www.classi.com.br'
            },
            {
              id: '2',
              title: 'Jornal Daqui',
              href: 'https://daqui.opopular.com.br'
            },
            {
              id: '3',
              title: 'Jornal O Popular',
              href: 'https://opopular.com.br/'
            },
            {
              id: '4',
              title: 'Jornal do Tocantins',
              href: 'https://www.jornaldotocantins.com.br'
            }
          ],
          css: accordionStyle
        }
      ]
    }
  },
  sectionFooter: {
    enabled: true,
    advertiseSection: {
      enabled: false,
      color: '',
      href: ''
    },
    socialmediasSection: {
      enabled: true,
      color: '$secondaryMain',
      content: [
        {
          id: 'facebook',
          href: 'https://www.facebook.com/radiocbn',
          icon: 'IcBotaoFacebook'
        },
        {
          id: 'twitter',
          href: 'https://twitter.com/CBNoficial',
          icon: 'IcBotaoTwitter'
        },
      ]
    }
  }
}
